import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';

/* Mismos colores que los lomos de los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-primary text-white', 'bg-teal text-ink', 'bg-coral text-ink', 'bg-violet text-white', 'bg-amber text-ink', 'bg-ink text-white'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-ink" data-id="element-149" data-mp="131hnfg40mje">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-150" data-mp="3t8wy5myc2u9j">
        <p className="font-sub text-sm font-semibold leading-tight text-tint" data-id="element-151" data-mp="aue8c3q696nu">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-152" data-mp="5wm4qcg5zw3t">
          <span className="text-coral" data-id="element-153" data-mp="fu0k08qcqeuj">270 mapas visuales</span> organizados en
          6 tomos para estudiar enfermería.
        </h2>
        <p className="mt-1 font-display text-xs font-extrabold uppercase leading-tight text-teal sm:text-sm" data-id="element-154" data-mp="36c6ur0zjnwwj">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/90" data-id="element-155" data-mp="3fbk65z78avjw">
          No es simplemente otro ebook de enfermería. Es un{' '}
          <strong className="font-bold text-tint" data-id="element-156" data-mp="3kbyg5mse4fkk">sistema visual</strong> que
          organiza los conocimientos fundamentales para ayudarte a comprender los
          temas, relacionar conceptos y repasar de forma más clara.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-157" data-mp="2tvqalej1grp">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-tint bg-surface text-left text-ink" data-id="element-158" data-mp="2w9kyt5aoqyq" data-mpi={i}>
              <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-159" data-mp="gsvfpv9v5zox">
                <span className="text-sm leading-none" aria-hidden="true" data-id="element-160" data-mp="2cuqc6ulf3nwj">
                  {tomo.emoji}
                </span>
                <span className="font-sub text-[10px] font-semibold uppercase tracking-wider" data-id="element-161" data-mp="2mmcpqxl89z2g">
                  Tomo
                </span>
                <span className="font-display text-2xl font-black leading-none" data-id="element-162" data-mp="2hubenezsqee0">
                  {i + 1}
                </span>
              </span>
              <div className="p-2.5" data-id="element-163" data-mp="2rlzbxwj1apne">
                <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-164" data-mp="2rkxnmqd0c6nq">
                  <span className="sr-only" data-id="element-165" data-mp="35lqlnl2ipjvl">Tomo {i + 1} — </span>
                  {tomo.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-muted sm:text-sm" data-id="element-166" data-mp="30nf8p1gxet95">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-167" data-mp="169ecypgoamda">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}